export default "__VITE_ASSET__BAoepIu0__"